import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=52e0a0ba&scoped=true"
import script from "./departmentList.vue?vue&type=script&lang=js"
export * from "./departmentList.vue?vue&type=script&lang=js"
import style0 from "./departmentList.vue?vue&type=style&index=0&id=52e0a0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e0a0ba",
  null
  
)

export default component.exports